import React, { useEffect, useState } from 'react';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleLanguage = () => {
    setLanguage(language === 'es' ? 'en' : 'es');
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-112">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-113">
        {/* Logo */}
        <a href="#" className="font-serif text-xl md:text-2xl tracking-wide transition-colors duration-300 text-white" data-id="element-114">
          Alexaaa Narvaez
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-115">
          <a href="#inicio" className="text-sm font-medium tracking-wide transition-colors duration-300 border-b-2 border-transparent hover:border-[#D4AF37] pb-1 text-white/90 hover:text-white" data-id="element-116">
            {t('nav.home')}
          </a>
          <a href="#galeria" className="text-sm font-medium tracking-wide transition-colors duration-300 border-b-2 border-transparent hover:border-[#D4AF37] pb-1 text-white/90 hover:text-white" data-id="element-117">
            {t('nav.gallery')}
          </a>

          {/* Language Toggle */}
          <button onClick={toggleLanguage} className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-sm text-sm font-medium tracking-wide transition-all duration-300 border border-white/20" data-id="element-118">
            <span className="text-xs" data-id="element-119">{language === 'es' ? '🇪🇸' : '🇺🇸'}</span>
            <span data-id="element-120">{language === 'es' ? 'ES' : 'EN'}</span>
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <div className="flex items-center gap-4 md:hidden" data-id="element-121">
          {/* Language Toggle Mobile */}
          <button onClick={toggleLanguage} className="flex items-center gap-1 bg-white/10 text-white px-3 py-1.5 rounded-sm text-xs font-medium border border-white/20" data-id="element-122">
            <span data-id="element-123">{language === 'es' ? '🇪🇸' : '🇺🇸'}</span>
            <span data-id="element-124">{language === 'es' ? 'ES' : 'EN'}</span>
          </button>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="transition-colors duration-300 text-white" data-id="element-125">
            <Icon name={isMobileMenuOpen ? 'x' : 'menu'} size={28} data-id="element-126" />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md shadow-xl transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-127">
        <nav className="flex flex-col p-6 gap-4" data-id="element-128">
          <a href="#inicio" onClick={() => setIsMobileMenuOpen(false)} className="text-white font-medium py-2 border-b border-white/10" data-id="element-129">
            {t('nav.home')}
          </a>
          <a href="#galeria" onClick={() => setIsMobileMenuOpen(false)} className="text-white font-medium py-2 border-b border-white/10" data-id="element-130">
            {t('nav.gallery')}
          </a>
        </nav>
      </div>
    </header>;
}